module.exports = __webpack_public_path__ + "static/media/siniestrosIconoGenerico.03ffa321.svg";